<template>
  <a-layout style="min-height: 100vh">
    <!-- 侧边栏 -->
    <a-layout-sider v-model:collapsed="collapsed" collapsible>
      <div class="logo">
        <h2 v-if="!collapsed" style="color: white; text-align: center; margin: 16px 0;">KK</h2>
        <h2 v-else style="color: white; text-align: center; margin: 16px 0;">系统</h2>
      </div>
      <a-menu
        v-model:selectedKeys="selectedKeys"
        theme="dark"
        mode="inline"
      >
        <a-menu-item v-for="item in menuItems" :key="item.path">
          <router-link :to="item.path">
            <span class="anticon">
              <component :is="getIcon(item.icon)" />
            </span>
            <span>{{ item.title }}</span>
          </router-link>
        </a-menu-item>
      </a-menu>
    </a-layout-sider>

    <!-- 主内容区域 -->
    <a-layout>
      <!-- 头部 -->
      <a-layout-header style="background: #fff; padding: 0 16px; display: flex; align-items: center; justify-content: space-between;">
        <div>
          <menu-unfold-outlined
            v-if="collapsed"
            class="trigger"
            @click="() => (collapsed = !collapsed)"
          />
          <menu-fold-outlined
            v-else
            class="trigger"
            @click="() => (collapsed = !collapsed)"
          />
        </div>
        <div>
          <a-dropdown>
            <a class="ant-dropdown-link" @click.prevent>
              {{ userInfo.name }} <down-outlined />
            </a>
            <template #overlay>
              <a-menu>
                <a-menu-item>
                  <router-link to="/profile">个人中心</router-link>
                </a-menu-item>
                <a-menu-item @click="handleLogout">
                  <a href="javascript:;">退出登录</a>
                </a-menu-item>
              </a-menu>
            </template>
          </a-dropdown>
        </div>
      </a-layout-header>

      <!-- 内容 -->
      <a-layout-content style="margin: 16px">
        <div style="padding: 24px; background: #fff; min-height: 360px">
          <router-view></router-view>
        </div>
      </a-layout-content>


    </a-layout>
  </a-layout>
</template>

<script>
import { ref, computed, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import {
  HomeOutlined,
  EyeOutlined,
  FileAddOutlined,
  OrderedListOutlined,
  TeamOutlined,
  AccountBookOutlined,
  MessageOutlined,
  UserOutlined,
  NotificationOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  DownOutlined,
  DollarOutlined
} from '@ant-design/icons-vue'
import { getUserInfo } from '@/api/api'

export default {
  name: 'MainLayout',
  components: {
    HomeOutlined,
    EyeOutlined,
    FileAddOutlined,
    OrderedListOutlined,
    TeamOutlined,
    AccountBookOutlined,
    MessageOutlined,
    UserOutlined,
    NotificationOutlined,
    MenuUnfoldOutlined,
    MenuFoldOutlined,
    DownOutlined,
    DollarOutlined
  },
  setup() {
    const collapsed = ref(false)
    const route = useRoute()
    const router = useRouter()
    // 添加用户信息响应式数据
    const userInfo = ref({
      name: '管理员'
    })

    // 获取用户信息
    const fetchUserInfo = async () => {
      try {
        const res = await getUserInfo()
        if (res.code === 200) {
          userInfo.value = res.data
        }
      } catch (error) {
        console.error('获取用户信息失败:', error)
      }
    }

    // 页面加载时获取用户信息
    onMounted(() => {
      fetchUserInfo()
    })

    // 当前选中的菜单项
    const selectedKeys = computed(() => {
      return [route.path]
    })

    // 获取图标组件
    const getIcon = (iconName) => {
      const iconMap = {
        'home-outlined': HomeOutlined,
        'eye-outlined': EyeOutlined,
        'file-add-outlined': FileAddOutlined,
        'ordered-list-outlined': OrderedListOutlined,
        'team-outlined': TeamOutlined,
        'account-book-outlined': AccountBookOutlined,
        'message-outlined': MessageOutlined,
        'user-outlined': UserOutlined,
        'notification-outlined': NotificationOutlined,
        'dollar-outlined': DollarOutlined
      }
      return iconMap[iconName]
    }

    // 菜单项配置
    const menuItems = computed(() => {
      // 获取用户角色
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
      // 解析roles字段，处理带有转义字符的JSON字符串
      let userRoles = []
      try {
        if (userInfo.roles) {
          const parsed = JSON.parse(userInfo.roles.replace(/\\/g, ''))
          userRoles = Array.isArray(parsed) ? parsed : [parsed]
        }
      } catch (e) {
        // roles 可能是普通字符串如 "admin"
        userRoles = userInfo.roles ? [userInfo.roles] : []
      }

      // 基础菜单项
      const items = [
        { path: '/home', title: '平台首页', icon: 'home-outlined' },
        { path: '/order', title: '查课下单', icon: 'eye-outlined' },
        { path: '/batchQuery', title: '批量查课', icon: 'eye-outlined' },
        { path: '/batchOrder', title: '批量下单', icon: 'file-add-outlined' },
        { path: '/orderManage', title: '国开订单', icon: 'ordered-list-outlined' },
        { path: '/shiyanOrder', title: '实验订单', icon: 'ordered-list-outlined' },
        { path: '/hebeiOrder', title: '河北开放', icon: 'ordered-list-outlined' },
        { path: '/agent', title: '我的代理', icon: 'team-outlined' },
        // { path: '/consumption', title: '消费记录', icon: 'account-book-outlined' },
        { path: '/feedback', title: '问题反馈', icon: 'message-outlined' },
        { path: '/profile', title: '个人中心', icon: 'user-outlined' },
        // { path: '/priceList', title: '价格列表', icon: 'dollar-outlined' }
      ]

      // 如果是管理员，添加公告编辑菜单项
      if (userRoles.includes('admin')) {
        items.push(
          { path: '/announcement', title: '公告编辑', icon: 'notification-outlined' }
        )
      }

      return items
    })

    // 退出登录处理函数
    const handleLogout = () => {
      // 清除token
      localStorage.removeItem('token')
      // 跳转到登录页
      router.push('/login')
    }

    return {
      collapsed,
      selectedKeys,
      menuItems,
      getIcon,
      handleLogout,
      userInfo
    }
  }
}
</script>

<style scoped>
.logo {
  height: 32px;
  margin: 16px;
  background: rgba(255, 255, 255, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.trigger {
  font-size: 18px;
  line-height: 64px;
  padding: 0 24px;
  cursor: pointer;
  transition: color 0.3s;
}

.trigger:hover {
  color: #1890ff;
}

/* 添加固定侧边栏的样式 */
:deep(.ant-layout-sider) {
  position: fixed;
  height: 100vh;
  left: 0;
  top: 0;
  bottom: 0;
  z-index: 1000;
  box-shadow: 2px 0 8px 0 rgba(29, 35, 41, 0.05);
}

/* 主内容区域添加左边距，为固定侧边栏留出空间 */
:deep(.ant-layout) {
  margin-left: 200px;
  transition: margin-left 0.2s;
}

/* 当侧边栏收起时，调整主内容区域的左边距 */
:deep(.ant-layout-sider-collapsed) + .ant-layout {
  margin-left: 80px;
}
</style>
